const Getters = {
  getLoadingListFromState: (state) => {
    return state.loadingList
  },
  getCancelCompletedFromState: (state) => {
    return state.cancelCompleted
  }
}

export default Getters
